@if (sources.length > 0) {
<div class="space-y-3 pl-1 pr-3 max-h-[calc(100vh-10rem)] overflow-y-auto">
   <ng-container *ngFor="let source of sources; let i = index">
      <div class="bg-slate-50 border border-gray-200 rounded-base p-3 flex flex-col gap-3">

         @if (source.file?.name) {
         <div class="flex justify-between items-center">
            <h2 class="font-bold text-md">{{ source.file.name }}
               <span class="pi pi-eye cursor-pointer" (click)="openDocumentPreview(source.file)"></span>
            </h2>
         </div>

         @if (source.content) {
         <p class="text-sm text-gray-700">
            @if (!expandedSourceIndexes[i]) {
            {{ truncateContent(source.content, 25) }}
            @if (source.content.split(' ').length > 25) {
            <app-button label="View More" variant="outlined" severity="secondary" (clicked)="toggleExpand(i)" />
            }
            } @else {
            {{ source.content }}
            <app-button label="View Less" variant="outlined" severity="secondary" (clicked)="toggleExpand(i)" />
            }
         </p>
         }
         }

         @if (source.qnaPair?.question?.title && source.qnaPair?.answer?.value) {
         <div class="flex justify-between items-center mt-2">
            <h2 class="font-bold text-md">{{ source.qnaPair.question.title }}</h2>
            @if (source.qnaPair?.active === false) {
            <span class="text-xs font-medium bg-red-100 text-danger px-2 py-0.5 rounded-base">Deleted</span>
            }
            <span class="text-xs font-medium bg-yellow-200 text-yellow-800 px-2 py-0.5 rounded-base">No of times used :
               {{source.qnaPair.timesUsed}}</span>
         </div>

         <p class="text-sm text-gray-700">
            @if (!expandedSourceIndexes['qna' + i]) {
            {{ truncateContent(source.qnaPair.answer.value, 25) }}
            @if (source.qnaPair.answer.value.split(' ').length > 25) {
            <button class="text-arena-blue cursor-pointer" (click)="toggleExpand('qna' + i)">
               View More
            </button>
            }
            } @else {
            {{ source.qnaPair.answer.value }}
            <button class="text-arena-blue cursor-pointer" (click)="toggleExpand('qna' + i)">
               View Less
            </button>
            }
         </p>
         }

      </div>
   </ng-container>
</div>
} @else {
<div class="flex items-center justify-center h-full w-full">
   <div class="mb-20 relative w-[18.75rem]">
      <img [src]="'images/Source.png' | assetUrl" class="h-[12.5rem] w-full object-cover" />
      <div class="absolute -right-1 -bottom-8 w-full px-2 text-center">
         <h1 class="text-xl font-semibold text-gray-800">No Sources Mapped</h1>
         <p class="text-sm text-gray-500">Sources and its fetched answers will be shown here</p>
      </div>
   </div>
</div>
}

<app-dialog [visible]="showDocumentPreview" [fullscreenOnMobile]="true" class="max-w-[60rem] h-[90vh]"
   (closed)="closeDocumentPreview()">
   <ng-template #headerTemplate>
      <div class="px-6 py-4 border-b border-gray-200">
         <div class="text-base font-bold">{{ selectedDocumentFile?.filename }}</div>
      </div>
   </ng-template>
   <ng-template #bodyTemplate>
      <div class="h-full w-full">
         @if(selectedDocumentFile && selectedDocumentId) {
         <app-document-preview class="h-full w-full" [documentId]="selectedDocumentId" [file]="selectedDocumentFile" />
         }
      </div>
   </ng-template>
</app-dialog>
